import { moneyFormater } from "../../../../utilities/formaters";

const TableCellMoney = ({ value, currency }) => {
  let money = 0;
  if (value) money = moneyFormater(Math.round(value * 100) / 100);
  return (
    <div className="table-cell-money">
      {money}&nbsp;{currency}
    </div>
  );
};

export default TableCellMoney;
